import { render, staticRenderFns } from "./AuditForm.vue?vue&type=template&id=66ace2e4&scoped=true"
import script from "./AuditForm.vue?vue&type=script&lang=js"
export * from "./AuditForm.vue?vue&type=script&lang=js"
import style0 from "./AuditForm.vue?vue&type=style&index=0&id=66ace2e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ace2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ace2e4')) {
      api.createRecord('66ace2e4', component.options)
    } else {
      api.reload('66ace2e4', component.options)
    }
    module.hot.accept("./AuditForm.vue?vue&type=template&id=66ace2e4&scoped=true", function () {
      api.rerender('66ace2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/riskOrder/AuditForm.vue"
export default component.exports